<template>
  <div>
    未找到您要访问的页面
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
    props: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
